<div class="estimate-label" (click)="showEstimate()" *ngIf="!focusInput"><span>{{formatDuration(inputControl.value)}}</span></div>
<div class="estimate-input" *ngIf="focusInput">
  <nb-form-field>
  <input
    #inputElement
    [formControl]="inputControl"
    ngxDuration
    nbInput
    [ngClass]="{'valid': inputControl.valid, 'invalid': inputControl.invalid}"
    (focusout)="changeDiffTime()"
    (keyup.enter)="changeDiffTime()"
    placeholder="Исходная оценка"/>
    <nb-icon nbSuffix [icon]="'alert-triangle-outline'" status="warning" *ngIf="inputControl.invalid"></nb-icon>
  </nb-form-field>
</div>
